import React from "react"
import FontPreview from "@kit/design/font-select/font-preview"

export const SYSTEM_FONTS =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif"

export const fontOptions = [
  {
    label: "System Font",
    value: SYSTEM_FONTS,
    supportedWeights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    component: <FontPreview label="System Font" font={SYSTEM_FONTS} />
  },
  {
    label: "Arial",
    value: `Arial, ${SYSTEM_FONTS}`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Arial" />
  },
  {
    label: "Arial Black",
    value: `"Arial Black", "Arial Bold", ${SYSTEM_FONTS}`,
    supportedWeights: [400],
    component: <FontPreview font="Arial Black" />
  },
  {
    label: "Century Gothic",
    value: `'Century Gothic', Avenir, 'Trebuchet MS', ${SYSTEM_FONTS}`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Century Gothic" />
  },
  {
    label: "Courier New",
    value: `'Courier New', Courier, monospace`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Courier New" />
  },
  {
    label: "Geneva",
    value: `Geneva, Calibri, ${SYSTEM_FONTS}`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Geneva" />
  },
  {
    label: "Georgia",
    value: `Georgia, Times, 'Times New Roman', serif`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Georgia" />
  },
  {
    label: "Lucida Grande",
    value: `'Lucida Grande', Verdana`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Lucida Grande" />
  },
  {
    label: "New York",
    value: `'New York', Charter, Georgia, serif`,
    supportedWeights: [400, 700],
    component: <FontPreview font="New York" />
  },
  {
    label: "Charter",
    value: `Charter, Georgia, Times, 'Times New Roman', serif`,
    supportedWeights: [400, 700, 900],
    component: <FontPreview font="Charter" />
  },
  {
    label: "Roboto",
    value: `Roboto, ${SYSTEM_FONTS}`,
    supportedWeights: [100, 300, 400, 500, 700, 900],
    component: <FontPreview font="Roboto" />,
    limited: true
  },
  {
    label: "Tahoma",
    value: `Tahoma, 'PT Sans', Ubuntu, ${SYSTEM_FONTS}`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Tahoma" />
  },
  {
    label: "Times New Roman",
    value: `'Times New Roman', Times, Georgia, serif`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Times New Roman" />
  },
  {
    label: "Verdana",
    value: `Verdana, ${SYSTEM_FONTS}`,
    supportedWeights: [400, 700],
    component: <FontPreview font="Verdana" />
  }
]

export const weightOptions = [
  {
    label: "Ultra Light",
    value: 100
  },
  {
    label: "Light",
    value: 200
  },
  {
    label: "Thin",
    value: 300
  },
  {
    label: "Normal",
    value: 400
  },
  {
    label: "Medium",
    value: 500
  },
  {
    label: "Semibold",
    value: 600
  },
  {
    label: "Bold",
    value: 700
  },
  {
    label: "Extra Bold",
    value: 800
  },
  {
    label: "Heavy",
    value: 900
  }
]

export function filterWeights(currentFontValue) {
  const font = fontOptions.find(option => option.value === currentFontValue)

  if (!font) return [{ value: 400, label: "Normal" }]

  const options = weightOptions.filter(option =>
    font.supportedWeights.includes(option.value)
  )

  return options
}

export function getFont(label) {
  const font = fontOptions.find(option => option.label === label)

  if (!font) {
    throw new Error(`Font "${label}" wasn't found.`)
  }

  return font.value
}
